module.exports = __webpack_public_path__ + "img/stop_btn.b65581d6.png";